<template>
    <main id="page_sub">
      <section id="page_contents">
        <h5>약관동의</h5>
        <span>서비스 이용약관 및 개인정보 수집, 이용에 동의해 주세요.</span>
        <ul class="uBox p_first">
          <li>모두 동의합니다.
            <span class="fr">
              <label for="all"></label>
              <label class="myCheckbox">
                <input type="checkbox" name="all" v-model="allSelected"  @click="selectAll"/>
                <span></span>
              </label>
            </span>
          </li>
        </ul>
        <div class="agreement">
          <div class="agreementCheck">
            <div class="agreementTit">경영지원플랫폼서비스 이용약관에 동의합니다. <a @click="popup('service')" style="cursor: pointer">내용보기</a> </div>
            <div class="agreementChk"><label class="myCheckbox"><input type="checkbox"  v-validate="'required'" name="p1"  v-model="clsAgrDt" @change="updateCheckAll"/><span></span></label></div>
          </div>
          <div class="agreementCheck">
            <div class="agreementTit">개인정보 수집 및 이용에 동의합니다. <a @click="popup('privacy')" style="cursor: pointer">내용보기</a> </div>
            <div class="agreementChk"><label class="myCheckbox"><input type="checkbox"   v-validate="'required'" name="p2" v-model="psiAgrDt" @change="updateCheckAll"/><span></span></label></div>
          </div>
          <div class="agreementCheck">
            <div class="agreementTit">E-Mail 마케팅정보 수신에 동의합니다. <span>(선택)</span></div>
            <div class="agreementChk">
              <label class="myCheckbox">
                <input type="checkbox" name="p3" v-model="mktEmailAgrDt" @change="updateCheckAll"/>
                <span></span></label>
            </div>
          </div>
          <div class="agreementCheck">
            <div class="agreementTit">SMS 마케팅정보 수신에 동의합니다. <span>(선택)</span></div>
            <div class="agreementChk">
              <label class="myCheckbox">
                <input type="checkbox" name="p4" v-model="mktSmsAgrDt" @change="updateCheckAll"/>
                <span></span></label>
            </div>
          </div>
        </div>
      </section>
      <!--- 버튼영역 --->
      <div class="btn_area">
        <button class="k-primary k-button k-big" data-role="button" role="button" aria-disabled="false" tabindex="0" @click="goMainPage">
          확인
        </button>
        <button data-role="button" class="k-button k-big" role="button" aria-disabled="false" tabindex="0" @click="cancelLogin">취소</button>
      </div>
      <!--- //버튼영역 --->

    </main>

</template>


<script>
  import JwtService from "@/common/jwt.service";

  export default {
    name    : 'FirstLoginForm',
    data () {
      return {
        userId: null,
        allSelected: false,
        clsAgrDt :false,
        psiAgrDt : false,
        mktEmailAgrDt: false,
        mktSmsAgrDt : false
      }
    },
    methods : {
      selectAll: function (e) {
        this.clsAgrDt = e.target.checked
        this.psiAgrDt = e.target.checked
        this.mktEmailAgrDt = e.target.checked
        this.mktSmsAgrDt = e.target.checked
      },
      updateCheckAll: function () {
        this.allSelected = this.clsAgrDt && this.psiAgrDt && this.mktEmailAgrDt && this.mktSmsAgrDt;
      },
      goMainPage: function () {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.$store.dispatch('FETCH_INSERT_USER_INFO',
              {"loginUserToken":JwtService.getToken(),
                "psiAgrDt" : this.psiAgrDt,
                "clsAgrDt": this.clsAgrDt,
                "mktEmailAgrDt": this.mktEmailAgrDt,
                "mktSmsAgrDt": this.mktSmsAgrDt})
            // 성공시 비밀번호 재설정으로 이동
              .then(data => {

                this.$router.push({name: 'UpdatePasswordForm'})
           //     this.$router.push({ name: 'Concierge'})
              })
          }else{
            kendo.alert("필수 약관에 동의해 주세요.")
          }
        })
      },
      cancelLogin : function () {
        const vm = this
        kendo.confirm("로그인 페이지로 이동합니다.")
          .done(function(){
            JwtService.destroyToken()
            vm.$router.push({name: 'Login'})
          })


      },
      popup: function (fileNm) {
        window.open('http://www.etners.com/privacy/ebmp/'+fileNm+'.html','_blank')
      }
    }
  }
</script>

<style>
  .close li {display: none;}
  .open li {display: block;}
</style>
